/**
 * Уведомления трекера (DEV-1966).
 *
 * Лента общая на всю платформу и разводится по приложению-адресату: до
 * DEV-1958 задачи трекера висели в колокольчике CRM, а своего у трекера не
 * было вовсе.
 */

/** Приложение-адресат: трекер читает только свои уведомления. */
export const NOTIFICATION_APP = 'tracker'

export interface Notification {
  id: string
  notificationType: string
  title: string
  body: string
  metadata: Record<string, unknown>
  channelsSent: string[]
  isRead: boolean
  createdAt: string
  readAt: string | null
  /** Приложение-адресат: для этой ленты всегда tracker. */
  app: string
  /**
   * Готовая ссылка перехода от бэкенда — абсолютная, уже развёрнутая базой
   * трекера. До DEV-1961 её не сохраняли, и уведомления трекера были
   * некликабельны.
   */
  url: string
}

export interface NotificationsListResponse {
  notifications: Notification[]
  total: number
  page: number
  pageSize: number
}
